import { Link } from "@/lib/router-compat";

/**
 * One-line SAINT® disclaimer shown in small print near the bottom of every
 * SAINT / TMS patient-education (/learn) page, linking to the full
 * /learn/saint-disclaimer page. Mirrors the EN/ES layouts.
 */
export const SaintDisclaimerNotice: React.FC<{ es?: boolean }> = ({
  es = false,
}) => (
  <p className="mt-8 border-t border-border/60 pt-4 text-xs leading-relaxed text-muted-foreground">
    {es ? (
      <>
        SAINT® solo lo ofrecen proveedores verificados en el sistema de Magnus
        Medical. Los programas descritos como &ldquo;alternativas&rdquo;,
        &ldquo;equivalentes&rdquo; o &ldquo;TMS acelerada guiada por fMRI&rdquo;
        de SAINT no son SAINT®, no están afiliados con nosotros, y los
        resultados de SAINT® no se aplican a ellos.{" "}
        <Link
          to="/es/learn/saint-disclaimer"
          className="font-medium text-accent underline underline-offset-2 hover:opacity-80"
        >
          Lea nuestro aviso de SAINT®
        </Link>
        .
      </>
    ) : (
      <>
        SAINT® is delivered only by verified providers on the Magnus Medical
        system. Programs described as SAINT &ldquo;alternatives&rdquo;,
        &ldquo;equivalents&rdquo; or &ldquo;fMRI-guided accelerated TMS&rdquo;
        are not SAINT®, are not affiliated with us, and SAINT® results do not
        apply to them.{" "}
        <Link
          to="/learn/saint-disclaimer"
          className="font-medium text-accent underline underline-offset-2 hover:opacity-80"
        >
          Read our SAINT® disclaimer
        </Link>
        .
      </>
    )}
  </p>
);

export default SaintDisclaimerNotice;
